<table mat-table [dataSource]="dataSource" class="table">
  <!-- id Column -->
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef class="index-column"></th>
    <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau société | header"
    >
      Nom
    </th>
    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
  </ng-container>

  <ng-container matColumnDef="usersLength">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau société | header"
    >
      Nbr d'utilisateurs
    </th>
    <td mat-cell *matCellDef="let element">{{ element.usersLength }}</td>
  </ng-container>

  <ng-container matColumnDef="currentData">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau société | header"
    >
      Data en cours
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.currentData | formatFileSize }}
    </td>
  </ng-container>

  <ng-container matColumnDef="currentTime">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau société | header"
    >
      Temps en cours
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.currentTime | formatTime }}
    </td>
  </ng-container>

  <ng-container matColumnDef="monthlyData">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau société | header"
    >
      Data / mois
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.monthlyData | formatFileSize }}
    </td>
  </ng-container>

  <ng-container matColumnDef="monthlyTime">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau société | header"
    >
      Temps / mois
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.monthlyTime | formatTime }}
    </td>
  </ng-container>

  <ng-container matColumnDef="totalTime">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau société | header"
    >
      Temps total
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.totalTime | formatTime }}
    </td>
  </ng-container>

  <ng-container matColumnDef="totalData">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau société | header"
    >
      Data total
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.totalData | formatFileSize }}
    </td>
  </ng-container>

  <ng-container matColumnDef="analysisDeletion">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau société | header"
    >
      Retention analyses
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.analysisDeletion }}
      <span i18n>jours</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="archivedIncidentDeletion">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau société | header"
    >
      Retention incidents archivés
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.archivedIncidentDeletion }}
      <span i18n>jours</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="treatmentDeletion">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau société | header"
    >
      Retention traitements
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.treatmentDeletion }}
      <span i18n>jours</span>
    </td>
  </ng-container>

  <!-- Settings Column -->
  <ng-container matColumnDef="settings">
    <th mat-header-cell *matHeaderCellDef class="settings-column"></th>
    <td mat-cell *matCellDef="let element">
      <a mat-icon-button [routerLink]="['/company', element.id]">
        <mat-icon>visibility</mat-icon>
      </a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
